export default __webpack_public_path__ + "static/media/information.fa79bad2.png";